import { AppRoutes } from '../_constants/AppRoutes';

export const isAllowedRouteForUnauthenticatedUsers = (path: string) => {
  // Strip trailing slashes so e.g. `/download/app` matches `/download/app/`,
  // mirroring the trailing-slash tolerance in `isAuthenticationRoute`.
  const normalize = (value: string) => value.replace(/\/+$/, '');

  return [AppRoutes.downloadApp.path].map(normalize).includes(normalize(path));
};
